import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import { removeCostItem, removeAll } from 'store/entities/cost-setup/cost-setup';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const CostItemDeleteModal = ({ setModalVisible, removeCostItem, removeAll, costItemId, setActiveForm, projectId }) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    if (costItemId) {
      removeCostItem(costItemId, { projectId });
    } else {
      removeAll(projectId);
    }

    setModalVisible(false);
    setActiveForm(null);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(costItemId ? translations.costSetup_deleteCostItem : translations.costSetup_deleteAllCost),
          content: (
            <>
              {t(
                costItemId
                  ? translations.costSetup_areYouSureYouWantToDeleteThisItem
                  : translations.costSetup_areYouSureYouWantToDeleteAllCost,
              )}
            </>
          ),
          footer: (
            <>
              <Button
                testId="cost-item-delete-modal-button-delete"
                label={t(translations.delete)}
                colored
                onClick={onDelete}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapDispatchToProps = { removeCostItem, removeAll };
const Container = withErrorBoundary(connect(null, mapDispatchToProps)(CostItemDeleteModal), { isModal: true });

export { Container as CostItemDeleteModal };
